/* import __COLOCATED_TEMPLATE__ from './theme-type-toggle.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type MessengerSettingsThemeProvider from 'embercom/services/messenger-settings-theme-provider';

import { LIGHT_THEME_TYPE, DARK_THEME_TYPE } from 'embercom/lib/messenger-settings/target-types';

type ThemeType = typeof LIGHT_THEME_TYPE | typeof DARK_THEME_TYPE;

type ThemeTypeToggleArgs = {
  fullWidth?: boolean;
  iconOnly?: boolean;
  disabled?: boolean;
};

interface Signature {
  Args: ThemeTypeToggleArgs;
}
export default class ThemeTypeToggle extends Component<Signature> {
  @service intl: $TSFixMe;
  @service appService: $TSFixMe;
  @service messengerSettingsThemeProvider!: MessengerSettingsThemeProvider;
  @service MessengerSettingsService: $TSFixMe;

  get app() {
    return this.appService.app;
  }

  get selectedValue() {
    return this.messengerSettingsThemeProvider.targetThemeType;
  }

  get themeOptions() {
    return [
      {
        value: LIGHT_THEME_TYPE,
        label: this.intl.t('messenger.theme-types.light-label'),
        icon: 'sun',
      },
      {
        value: DARK_THEME_TYPE,
        label: this.intl.t('messenger.theme-types.dark-label'),
        icon: 'moon',
      },
    ];
  }

  @action
  setThemeType(newTheme: ThemeType) {
    this.messengerSettingsThemeProvider.targetThemeType = newTheme;
    this.trackThemeToggle(newTheme);
  }

  trackThemeToggle(theme: ThemeType) {
    this.MessengerSettingsService.trackAnalyticsEvent({
      action: 'toggled',
      object: 'theme_type',
      toggled_to: theme,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Common::ThemeTypeToggle': typeof ThemeTypeToggle;
    'messenger-settings/common/theme-type-toggle': typeof ThemeTypeToggle;
  }
}
